exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3F6YDnsfvNwE1Fh1d60bY3{height:90vh;width:90vw;overflow-y:hidden}._1Ic9Hee0b4l52c06nRl2v2{height:100%}._2Xv4cuN3PIU7Ku5Pn2hyMm{display:-webkit-box;display:-ms-flexbox;display:flex;min-width:100%;height:calc(100% - 40px)}html[dir] ._2Xv4cuN3PIU7Ku5Pn2hyMm{padding:0}._2AXqLDEmcvBu0-lhsX6Ggt{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}", ""]);
// Exports
exports.locals = {
	"modalContainer": "_3F6YDnsfvNwE1Fh1d60bY3",
	"filePickerContent": "_1Ic9Hee0b4l52c06nRl2v2",
	"content": "_2Xv4cuN3PIU7Ku5Pn2hyMm",
	"filePickerPane": "_2AXqLDEmcvBu0-lhsX6Ggt"
};